import ERROR_CODES from './errorCodes';

export default {
  // [ERROR_CODES.INTERNAL_SERVER_ERROR]: "Something went wrong.",
  [ERROR_CODES.WRONG_USERNAME_OR_PASSWORD]: "Username or password is not correct.",
  [ERROR_CODES.INVALID_RECAPTCHA_TOKEN]: "Your reCAPTCHA response is not valid.",
  [ERROR_CODES.EMAIL_IS_NOT_VERIFIED]: "Your email is not verified.",
  [ERROR_CODES.NEW_IP_DETECTED]: "Unknown IP address",
  [ERROR_CODES.USER_IS_DEACTIVED]: "Your account has been deactivated.",
  [ERROR_CODES.FORGET_PASSWORD_EXCEED_LIMIT]: "You have exceeded the request limit for recovering password. Please try again later.",
  [ERROR_CODES.USER_NOT_FOUND]: "This email is not registered on Unagii. Please enter a valid email.",
  [ERROR_CODES.AUTH_TOKEN_EXPIRED]: "Token is not valid.",
  [ERROR_CODES.AUTH_TOKEN_INVALID]: "Token is not valid.",
  [ERROR_CODES.UNAUTHORIZED]: "Unauthorized.",
  [ERROR_CODES.NEW_PASSWORD_INVALID]: "New password is invalid.",
  [ERROR_CODES.INCORRECT_PASSWORD]: "Current password is not correct.",
  [ERROR_CODES.USER_EXISTING]: "Email is already used.",
  [ERROR_CODES.CONFIRMATION_CODE_EXPIRED]: "Confirmation code is not valid.",
  [ERROR_CODES.CONFIRMATION_CODE_INVALID]: "Confirmation code is not valid.",
  [ERROR_CODES.TWO_FA_AREALDY_ENABLED]: "Two-factor authentication is already enabled",
  [ERROR_CODES.TWO_FA_SECRET_NOT_FOUND]: "Secret not found",
  [ERROR_CODES.TWO_FA_VERIFICATION_CODE_INVALID]: "The code you provided is not correct.",
  [ERROR_CODES.TWO_FA_IS_NOT_ENABLED]: "Two-factor authentication is not enabled.",
  [ERROR_CODES.TWO_FA_VERIFICATION_CODE_NOT_FOUND]: "Two-factor authentication code required.",
  [ERROR_CODES.ADDRESS_EXISTING]: 'Account with this address is already connected.',
  // [ERROR_CODES.COIN_NETWORK_NOT_FOUND]: 'COIN_NETWORK_NOT_FOUND',
  // [ERROR_CODES.ID_NOT_FOUND]: 'ID_NOT_FOUND',
  // [ERROR_CODES.CAN_NOT_BE_REMOVED]: 'CAN_NOT_BE_REMOVED',
  // [ERROR_CODES.INVALID_STATE]: 'INVALID_STATE',
  // [ERROR_CODES.RESOURCE_EXISTING]: 'RESOURCE_EXISTING',
  // [ERROR_CODES.INVALID_ADDRESS]: 'INVALID_ADDRESS',
  // [ERROR_CODES.INVALID_TRANSACTION]: 'INVALID_TRANSACTION',
  // [ERROR_CODES.INVALID_INVITATION_CODE]: 'INVALID_INVITATION_CODE',
  // [ERROR_CODES.EXCEED_ACCOUNT_LIMIT]: 'EXCEED_ACCOUNT_LIMIT',
  // [ERROR_CODES.NOT_SUPPORTED]: 'NOT_SUPPORTED',
  // [ERROR_CODES.UNAGII_CASH_WALLET_NOT_FOUND]: 'UNAGII_CASH_WALLET_NOT_FOUND',
  // [ERROR_CODES.EXCEED_REQUEST_RATE_LIMIT]: 'EXCEED_REQUEST_RATE_LIMIT',
};
